import React, { useCallback, useContext, useEffect, useState } from "react";

import { ALLOW, hasAnyRole } from "../../auth/access";
import { getPendingInstructorRatings } from "../../api/instructorRatingsService";
import {
   closePopup,
   getCurrentPopup,
   openPopup,
   subscribePopup,
} from "../Common/popupUIStore";
import { UserContext } from "../../UserContext";

export default function StudentMandatoryRatingsGate() {
   const { user, loading } = useContext(UserContext);
   const isStudent = hasAnyRole(user, ALLOW.STUDENT);

   const [pendingCount, setPendingCount] = useState(0);

   const refreshPending = useCallback(async () => {
      if (!isStudent) {
         setPendingCount(0);
         return 0;
      }

      try {
         const rows = await getPendingInstructorRatings();
         const count = Array.isArray(rows) ? rows.length : 0;
         setPendingCount(count);
         return count;
      } catch {
         setPendingCount(0);
         return 0;
      }
   }, [isStudent]);

   useEffect(() => {
      if (loading || !user || !isStudent) return;
      refreshPending();
   }, [isStudent, loading, refreshPending, user]);

   useEffect(() => {
      if (!isStudent) return undefined;

      const handleFocus = () => {
         refreshPending();
      };

      const handleVisibility = () => {
         if (document.visibilityState === "visible") {
            refreshPending();
         }
      };

      window.addEventListener("focus", handleFocus);
      document.addEventListener("visibilitychange", handleVisibility);

      return () => {
         window.removeEventListener("focus", handleFocus);
         document.removeEventListener("visibilitychange", handleVisibility);
      };
   }, [isStudent, refreshPending]);

   useEffect(() => {
      if (!isStudent) return undefined;

      return subscribePopup(() => {
         const current = getCurrentPopup();
         if (!current || current.type !== "studentMandatoryRatings") {
            refreshPending();
         }
      });
   }, [isStudent, refreshPending]);

   useEffect(() => {
      if (!isStudent) return;

      const currentType = getCurrentPopup()?.type;

      if (pendingCount > 0) {
         if (currentType !== "studentMandatoryRatings") {
            openPopup("studentMandatoryRatings");
         }
         return;
      }

      if (currentType === "studentMandatoryRatings") {
         closePopup();
      }
   }, [isStudent, pendingCount]);

   return null;
}
